import { render } from "./TableColumn.vue?vue&type=template&id=36dbee1e"
import script from "./TableColumn.vue?vue&type=script&lang=js"
export * from "./TableColumn.vue?vue&type=script&lang=js"

import "./TableColumn.vue?vue&type=style&index=0&id=36dbee1e&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__